/* eslint-disable func-names */
require('jqmask');

$(() => {
  $("[data-id='zip']").mask('9999?9', { placeholder: '' });

  $("[data-id='tel'], [data-id='mobile']").mask('99999999999999', {
    placeholder: '',
    translation: {
      9: {
        pattern: /[0-9]/,
        optional: true
      }
    }
  });
});

$('.m-account-info-saved__edit-btn').click(() => {
  setTimeout(() => {
    $("[data-id='zip']").mask('9999?9', { placeholder: '' });
  }, 200);
});



// WEBPACK FOOTER //
// ./js/countryForm/slovakia.form.js